//
// Remove the scrolling increment/decrement behavior from number input elements
// --------------------------------------------------
document.addEventListener("wheel", function(event) {
	if(document.activeElement.type === "number"){
		document.activeElement.blur();
	}
}, passiveEventListenerOptionSupported ? { passive: true } : false);
